import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API_URL from '../config';

const AdminSignup = () => {
  const [form, setForm] = useState({ username: '', password: '', confirmPassword: '', email: '', fullName: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    if (form.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    
    setLoading(true);
    
    try {
      const res = await fetch(`${API_URL}/admin/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: form.username, password: form.password, email: form.email, fullName: form.fullName })
      });
      
      const data = await res.json();
      
      if (res.ok) {
        setSuccess('Admin account created successfully! Redirecting to login...');
        setTimeout(() => navigate('/admin/login'), 2000);
      } else {
        setError(data.message || 'Failed to create account');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-form">
        <h1>👥 Create Admin Account</h1>
        <p>Register a new administrator account</p>
        
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label>Full Name *</label><input type="text" name="fullName" value={form.fullName} onChange={handleChange} required placeholder="John Doe" /></div>
          <div className="form-group"><label>Email *</label><input type="email" name="email" value={form.email} onChange={handleChange} required placeholder="admin@golfstore.com" /></div>
          <div className="form-group"><label>Username *</label><input type="text" name="username" value={form.username} onChange={handleChange} required placeholder="Choose a username" /></div>
          <div className="form-group"><label>Password *</label><input type="password" name="password" value={form.password} onChange={handleChange} required placeholder="Min 6 characters" /></div>
          <div className="form-group"><label>Confirm Password *</label><input type="password" name="confirmPassword" value={form.confirmPassword} onChange={handleChange} required /></div>
          
          <button type="submit" className="btn-primary" disabled={loading} style={{ width: '100%' }}>
            {loading ? 'Creating...' : 'Create Admin Account →'}
          </button>
        </form>
        
        <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
          <Link to="/admin/login" style={{ color: '#2a5a3a', textDecoration: 'none' }}>← Back to Login</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminSignup;